export default __webpack_public_path__ + "asset/img/goods-detail-coupon-01~6802ff8e.png";